export enum PackageOptions {
  edit,
  duplicate,
  delete,
}

export interface tab {
  active: boolean;
  value: number;
  label: string;
}

export const tabs: tab[] = [
  {
    label: 'Custom package',
    value: 1,
    active: true,
  },
  {
    label: 'Carrier package',
    value: 2,
    active: false,
  },
];

export enum VariantColumnsForMetafieldInput {
  Length = 'length',
  Width = 'width',
  Height = 'height',
  DistanceUnit = 'distanceUnit',
}

export interface VariantMetafieldMapping {
  [namespace: string]: {
    [key: string]: VariantColumnsForMetafieldInput;
  };
}
